module.exports = __webpack_public_path__ + "img/Wikidata-logo.60925e15.svg";